import React, { useEffect, useState } from "react";
import { Card, Table, Spinner, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, Navigate } from "react-router-dom";
import PrivateMasterPage from "../../layout/PrivateMasterPage";

import { Container } from "./styles";
import { module_names } from "../../constants/module_names";
import CustomThead from "../../components/CustomThead";
import { SensorsService } from "../../core/services/SensorsService";

import { isErrorResult } from "../../core/utils/api";
import TableFooter from "../../components/TableFooter";
import TableActions from "../../components/TableActions";
import { IAlertRuleBody } from "../Sensors/AlertRuleForm";
import { ProtectedComponent } from "../../components/ProtectedComponent";
import AddButton from "../../components/AddButton";
import NewSensorModal from "../../components/NewSensorModal";
import NewSensorAttachVehicleModal from "../../components/NewSensorAttachVehicleModal";
import { useAppDispatch } from "../../core/redux/hooks";
import { updateAlert } from "../../core/redux/reducer/alert";

const AttachSensorPage: React.FC = () => {
  const { t } = useTranslation();

  const [pagination, setPagination] = useState({
    page: 1,
    pages: 0,
    filter: "",
    order: { date_time: "desc" },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [vehiclesSensors, setVehiclesSensors] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [newSensorModal, setNewSensorModal] = useState(false);
  const [newSensorAttachModal, setNewSensorAttachModal] = useState(false);
  const [selectedAttach, setSelectedAttach] = useState<any | null>(null);
  const dispatch = useAppDispatch();
  const closeNewSensorModal = () => {
    setNewSensorModal(false);
  };
  const closeNewSensorAttachModal = () => {
    setNewSensorAttachModal(false);
  };
  const actions = {
    option_add_vehicle: t("attach_sensor.option_add_vehicle"),
  };
  const actionOptions = Object.values(actions);

  const loadSensors = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await SensorsService.getVehiclesSensors(pagination);

      if (isErrorResult(response)) {
        throw new Error(t("errors.fetch_failed"));
      }

      setVehiclesSensors(response.data || []);
      setPagination((prev) => ({
        ...prev,
        pages: response.meta?.last_page || 0,
      }));
    } catch (err) {
      //@ts-ignore
      setError(err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadSensors();
  }, [pagination.page, pagination.filter, pagination.order]);

  const handleSelectAction = (action: string, data: any) => {
    console.log("Ação selecionada:", action, data);
    //  setAlertSelected(data.id);
    if (action === t("attach_sensor.option_add_vehicle")) {
      console.log("Ação selecionada:", action, data);
      setNewSensorAttachModal(true);
    }
    setSelectedAttach(data);
    //  if (action === actions.add_comment) {
    //    setShowModal("add_comment");
    //  } else if (action === actions.view) {
    //    setShowModal("view_comments");
    //  } else if (action === actions.view_media) {
    //    if (data?.data) {
    //      setMedia(data.data);
    //      setShowModal("view_media");
    //    }
    //  }
  };

  const handleActions = (item: IAlertRuleBody) => {
    return item.data
      ? actionOptions
      : actionOptions.filter(
          (action) => action !== t("alerts.option_view_media")
        );
  };
  const handleAttachSensor = (data: any) => {
    console.log("attach submit ->", data);
    console.log("attach submit ->", selectedAttach);
    const payload = {
      license_plate: data.vehiclePlate.label,
      sensor_id: selectedAttach?.sensor_id,
    };
    console.log("attach submit payload ->", payload);
    try {
      SensorsService.setVehicle(payload);
      loadSensors();
      dispatch(
        updateAlert({
          title: t("sensors.attach.vehicle.success.title"),
          message: t("sensors.attach.vehicle.success.message"),
          type: "success",
        })
      );
      closeNewSensorAttachModal();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        t("sensors.attach.vehicle.error.title");
      const sensorError = error?.response?.data?.errors?.sensor_id?.[0];

      dispatch(
        updateAlert({
          title: t("sensors.attach.vehicle.error.title"),
          message: errorMessage || "",
          type: "error",
        })
      );
    }
  };
  return (
    <PrivateMasterPage
      title={t("alerts.alert_title")}
      breadcrumb={[t("alerts.alert_title")]}
    >
      <ProtectedComponent
        module_name={module_names.ALERTS}
        property="view"
        fallbackComponent={<Navigate to="/configs/company" />}
      >
        <Container fluid className="p-3">
          <Card className="mb-5">
            <Card.Body className="p-4">
              <h4>{t("sensors.attach_sensor_title")}</h4>
              <Row className="mb-4">
                <Row>
                  {" "}
                  <Col
                    className="d-flex align-items-start justify-start mb-3"
                    xl={6}
                    lg={6}
                  >
                    <AddButton onClick={() => setNewSensorModal(true)}>
                      {t("new_sensor_modal.title")}
                    </AddButton>
                  </Col>
                </Row>
              </Row>

              {isLoading && (
                <div className="text-center my-3">
                  <Spinner animation="border" />
                  <p>{t("loading")}</p>
                </div>
              )}

              {error && <p className="text-danger">{error}</p>}

              {!isLoading && !error && (
                <>
                  <Table responsive hover>
                    <CustomThead
                      data={[
                        {
                          column: "sensor_id",
                          name: t("sensors.table_sensor"),
                        },
                        {
                          column: "sensor_type",
                          name: t("sensors.table_type"),
                        },
                        { column: "plate", name: t("sensors.table_vehicle") },
                        { column: "menu", name: <th />, menu: true },
                      ]}
                      onChangeOrder={(order) =>
                        //@ts-ignore
                        setPagination((prev) => ({ ...prev, order }))
                      }
                    />
                    <tbody>
                      {vehiclesSensors.map((vehicle, index) => (
                        <tr key={`sensor_${index}`}>
                          <td>
                            <Link to={`/sensors/${vehicle.sensor_id}`}>
                              {vehicle.sensor_id}
                            </Link>
                          </td>
                          <td>{vehicle.sensor_type}</td>
                          <td>{vehicle.license_plate}</td>
                          <td>
                            <TableActions
                              id={index}
                              items={handleActions(vehicle)}
                              onSelectAction={(action) =>
                                handleSelectAction(action, vehicle)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <TableFooter
                    paginate={{
                      current_page: pagination.page,
                      qtd: pagination.pages,
                      onSelectPage: (page) => {
                        setPagination((prev) => ({ ...prev, page }));
                      },
                    }}
                  />
                </>
              )}
            </Card.Body>
          </Card>
          <NewSensorModal
            visible={newSensorModal}
            onClose={closeNewSensorModal}
          />
          <NewSensorAttachVehicleModal
            visible={newSensorAttachModal}
            onClose={closeNewSensorAttachModal}
            data={selectedAttach}
            onSubmit={(data: any) => {
              handleAttachSensor(data);
            }}
          />
        </Container>
      </ProtectedComponent>
    </PrivateMasterPage>
  );
};

export default AttachSensorPage;
